import React, { useState } from 'react';
import './styles.css';
import { DESIGN_CONFIG, ERROR_TYPES, STRING_CONFIG } from 'utils';
import Box from 'ReusableComponents/Box';
import Text from 'ReusableComponents/Text';
import Input from 'ReusableComponents/Input';
import Button from 'ReusableComponents/Button';
import StyledLink from 'ReusableComponents/Link';
import { getTrialHeader, googleOAuth, userSignIn, userTrialMode } from 'api/authRequests';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { GoogleLogin } from '@react-oauth/google';
import { useMedia } from 'helpers';
import { showToast } from 'store/platform/actions';
import { isToken, isTrialMode, showAuthModal, userDetails } from '../../store/auth/actions';
import { CircularProgress } from '@material-ui/core';

function SignIn({ setAuthInterface, isModal, setUserEmail, setUserImage }) {
  const dispatch = useDispatch();

  const history = useHistory();

  const smallDevice = useMedia('(max-width:450px)');

  const authToken = useSelector((state) => state.auth.token);

  const [username, setUserName] = useState('');

  const [password, setPassword] = useState('');

  const [errorInUsername, setErrorInUsername] = useState(false);

  const [errorInPassword, setErrorInPassword] = useState(false);

  const [loading, setLoading] = useState(false);

  const loginViaOauth = async (tokenId) => {
    const googleToken = {
      token: tokenId,
    };
    try {
      const { data } = await googleOAuth(googleToken, authToken);
      if (data.success === true && data.isNewUser) {
        setUserImage(data.image);

        setUserEmail(data.email);

        setAuthInterface(3);
      } else if (data.success === true) {

        const userDetailsObj = {
          dateOfBirth: data?.dateOfBirth,
          email: data.email,
          firstName: data.firstName,
          gender: data?.gender,
          image: data.image,
          isOAuth: data.isOAuth,
          lastName: data.lastName,
          phone: data?.phone,
          username: data.username,
        };

        dispatch(userDetails(userDetailsObj));

        dispatch(isToken(data.token));

        dispatch(isTrialMode(null));

        dispatch(showAuthModal(false));
      }
    } catch (err) {
      dispatch(showAuthModal(false));
      if (err.response) {
        if (err.response.status === 409) {
          dispatch(
            showToast(
              STRING_CONFIG.inPage.toastMessages.txtEmailAlreadyRegistered,
              'error',
              6000,
              false,
              true
            )
          );
        } else if (err.response.status === 401) {
          dispatch(
            showToast(
              STRING_CONFIG.inPage.toastMessages.txtInvalidAuthToken,
              'error',
              6000,
              false,
              true
            )
          );
        }
      } else if (err.request) {
        dispatch(
          showToast(
            STRING_CONFIG.inPage.toastMessages.txtErrorSomethingWentWrong,
            'error',
            6000,
            false,
            true
          )
        );
      }
    }
  };

  const responseGoogleSuccess = (response) => {
    if (response.credential) {
      loginViaOauth(response.credential);
    }
  };

  const responseGoogleFailure = () => {
    dispatch(
      showToast(
        STRING_CONFIG.inPage.dialogMessages.txtOAuthError,
        'error',
        6000,
        false,
        true
      )
    );
  };

  const handleChangeUsername = (e) => {
    const val = e.target.value;

    if (val && errorInUsername) setErrorInUsername(false);
    setUserName(val);
  };

  const handleChangePassword = (e) => {
    const val = e.target.value;
    if (val && errorInPassword) setErrorInPassword('');
    setPassword(e.target.value);
  };

  const handleSubmit = async () => {
    if (loading) return;

    const trimmedUsername = username.trim();

    if (!trimmedUsername) {
      setErrorInUsername(ERROR_TYPES.LEFT_BLANK);
      return;
    }

    const trimmedPassword = password.trim();

    if (!trimmedPassword) {
      setErrorInPassword(ERROR_TYPES.LEFT_BLANK);
      return;
    }

    if (trimmedUsername.includes(' ')) {
      setErrorInUsername(ERROR_TYPES.NO_SPACES_ALLOWED);
      return;
    }

    try {
      setLoading(true);

      const mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

      const isEmail = mailformat.test(trimmedUsername);

      const credentials = {
        [isEmail ? 'email' : 'username']: trimmedUsername,
        password,
      };

      const { data } = await userSignIn(credentials);
      if (data.success === true) {

        setLoading(false);

        const userDetailsObj = {
          dateOfBirth: data?.data?.dateOfBirth,
          email: data.data.email,
          firstName: data.data.firstName,
          gender: data?.data?.gender,
          image: data?.data?.imageURL,
          isOAuth: data.data.isOAuth,
          lastName: data.data.lastName,
          phone: data?.data?.phone,
          username: data.data.username,
        };

        dispatch(userDetails(userDetailsObj));

        dispatch(isToken(data.data.token));

        dispatch(showAuthModal(false));

        dispatch(isTrialMode(null));

      }
    } catch (err) {
      setLoading(false);
      if (err.response) {
        if (err.response.status === 401) {
          dispatch(
            showToast(
              STRING_CONFIG.inPage.toastMessages.txtSignInFailed,
              'error',
              6000,
              false,
              true
            )
          );
        }
      } else if (err.request) {
        dispatch(
          showToast(
            STRING_CONFIG.inPage.toastMessages.txtErrorSomethingWentWrong,
            'error',
            6000,
            false,
            true
          )
        );
      }
    }
  };

  return (
    <form
      className='user-auth__sign-in'
      style={{
        borderRadius: `${isModal ? '.5rem' : '.75rem'}`,
        margin: `${isModal ? 'auto' : 'auto'}`,
      }}
    >
      <Box display='flex' flexDirection='column'>
        <h1
          style={{
            fontSize: `${smallDevice ? '1.25rem' : DESIGN_CONFIG.typography.largeCards.webLgCardTitle.fontSize}`,
            fontWeight: `${smallDevice ? 600 : DESIGN_CONFIG.typography.largeCards.webLgCardTitle.fontWeight}`,
            margin: 0,
          }}
        >
          {STRING_CONFIG.inPage.signIn.txtTitle}
        </h1>
        <p
          style={{
            color: `${DESIGN_CONFIG.color.text.text200}`,
            fontSize: `${smallDevice ? '.875rem' : DESIGN_CONFIG.typography.largeCards.webLgCardSubtitle.fontSize}`,
            fontWeight: `${smallDevice ? 400 : DESIGN_CONFIG.typography.largeCards.webLgCardSubtitle.fontWeight}`,
            marginBottom: 0,
          }}
        >
          {STRING_CONFIG.inPage.signIn.txtSubtext}
          <button
            type='button'
            onClick={() => setAuthInterface(2)}
            style={{
              background: 'transparent',
              border: 'none',
              color: `${DESIGN_CONFIG.color.primary.primaryMain}`,
              cursor: 'pointer',
              fontSize: `${smallDevice ? '.875rem' : DESIGN_CONFIG.typography.largeCards.webLgCardSubtitle.fontSize}`,
              fontWeight: `${smallDevice ? 400 : DESIGN_CONFIG.typography.largeCards.webLgCardSubtitle.fontSize}`,
            }}
          >
            {smallDevice ? STRING_CONFIG.inPage.common.txtSignUp : STRING_CONFIG.inPage.common.txtSignUpForFree}
          </button>
        </p>
        <Box display='flex' justifyContent='center' marginTop='1rem'>
          <GoogleLogin
            context='signin'
            onError={responseGoogleFailure}
            onSuccess={responseGoogleSuccess}
            width={!smallDevice && '420px'}
          />
        </Box>
        <Box display='flex' gap='0.688rem' marginTop='1.375rem'>
          <Box
            background={DESIGN_CONFIG.color.neutral.neutral200}
            h='1px'
            w='100%'
          />
          <p
            style={{
              bottom: '0.688rem',
              color: `${DESIGN_CONFIG.color.neutral.neutral200}`,
              fontSize: `${DESIGN_CONFIG.typography.common.webLabel.fontSize}`,
              fontWeight: `${DESIGN_CONFIG.typography.common.webLabel.fontWeight}`,
              position: 'relative',
            }}
          >
            {STRING_CONFIG.inPage.common.txtOr}
          </p>
          <Box
            background={DESIGN_CONFIG.color.neutral.neutral200}
            h='1px'
            w='100%'
          />
        </Box>
        <Box>
          <Box>
            <Box display='flex' flexDirection='column'>
              <label
                htmlFor='username'
                style={{ marginBottom: 8, display: 'flex' }}
              >
                <Text
                  fontSize={DESIGN_CONFIG.typography.common.webLabel.fontSize}
                  fontWeight={
                    DESIGN_CONFIG.typography.common.webLabel.fontWeight
                  }
                  margin={0}
                  textColor={DESIGN_CONFIG.color.text.text100}
                >
                  {STRING_CONFIG.inPage.signIn.lblUsername}
                </Text>
              </label>
              <Input
                border={`1px solid ${DESIGN_CONFIG.color.neutral.neutral100}`}
                borderRadius='6px'
                data-cy='username'
                error={errorInUsername}
                h='3rem'
                id='username'
                mw='100%'
                onChange={handleChangeUsername}
                p='.875rem 1rem'
                placeholder={STRING_CONFIG.inPage.signIn.plHUsernameEmail}
                type='text'
                value={username}
              />
              {errorInUsername && (
                <Box>
                  <Text
                    fontSize={DESIGN_CONFIG.typography.common.webLabel.fontSize}
                    fontWeight={
                      DESIGN_CONFIG.typography.common.webLabel.fontWeight
                    }
                    marginTop='.625rem'
                    role='alert'
                    textColor={DESIGN_CONFIG.color.error.errorMain}
                  >
                    {errorInUsername}
                  </Text>
                </Box>
              )}
            </Box>
            <Box display='flex' flexDirection='column' marginTop='1rem'>
              <label
                htmlFor='password'
                style={{
                  display: 'flex',
                  marginBottom: '.5rem',
                }}
              >
                <Text
                  fontSize={DESIGN_CONFIG.typography.common.webLabel.fontSize}
                  fontWeight={
                    DESIGN_CONFIG.typography.common.webLabel.fontWeight
                  }
                  margin={0}
                  textColor={DESIGN_CONFIG.color.text.text100}
                >
                  {STRING_CONFIG.inPage.userProfile.lblPassword}
                </Text>
              </label>
              <Input
                border={`1px solid ${DESIGN_CONFIG.color.neutral.neutral100}`}
                borderRadius='6px'
                data-cy='password'
                error={errorInPassword}
                h='48px'
                id='password'
                mw='100%'
                onChange={handleChangePassword}
                p='.875rem 1rem'
                placeholder={STRING_CONFIG.inPage.userProfile.plHPassword}
                type='password'
                value={password}
              />
              {errorInPassword && (
                <Box>
                  <Text
                    fontSize={DESIGN_CONFIG.typography.common.webLabel.fontSize}
                    fontWeight={
                      DESIGN_CONFIG.typography.common.webLabel.fontWeight
                    }
                    marginTop='.625rem'
                    role='alert'
                    textColor={DESIGN_CONFIG.color.error.errorMain}
                  >
                    {errorInPassword}
                  </Text>
                </Box>
              )}
            </Box>
            <Box
              alignItems='center'
              display='flex'
              justifyContent='end'
              marginBottom='1.5rem'
              marginTop='1.5rem'
              maxW='35.625rem'
            >
              <StyledLink
                color={DESIGN_CONFIG.color.primary.primaryMain}
                fontSize={DESIGN_CONFIG.typography.common.webLink.fontSize}
                fontWeight={DESIGN_CONFIG.typography.common.webLink.fontWeight}
                to='/initiate-forgot-password'
              >
                {STRING_CONFIG.inPage.signIn.lnkForgotPassword}
              </StyledLink>
            </Box>
          </Box>
        </Box>
      </Box>
      <Button
        alignItems='center'
        aria-disabled={loading || errorInUsername || errorInPassword}
        background={DESIGN_CONFIG.color.primary.primaryMain}
        border={`1px solid ${DESIGN_CONFIG.color.primary.primaryMain}`}
        borderRadius='6px'
        cursor={!loading ? 'pointer' : 'not-allowed'}
        data-cy='submit'
        disabled={loading || errorInUsername || errorInPassword}
        display='flex'
        justifyContent='center'
        onClick={handleSubmit}
        padding='.5rem'
        w='100%'
      >
        <Text
          fontSize={DESIGN_CONFIG.typography.common.webButton.fontSize}
          fontWeight={DESIGN_CONFIG.typography.common.webButton.fontWeight}
          marginBottom='0'
          textColor={DESIGN_CONFIG.color.neutral.neutral500}
        >
          {loading ? <CircularProgress size={18} color={DESIGN_CONFIG.color.neutral.neutral500} /> : STRING_CONFIG.inPage.common.txtSignIn}
        </Text>
      </Button>
    </form>
  );
}

export default SignIn;
